import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const PriceDiscount = ({ price, discountPrice }) => {
  if (price && discountPrice) {
    return (
      <div className="price-discount">
        <div className="price-discount__value">{discountPrice}</div>
        <div className="price-discount__value price-discount__value--original">{price}</div>
      </div>
    );
  } else {
    return (
      <div className="price-discount">
        <div className="price-discount__value">{price}</div>
      </div>
    );
  }
};

PriceDiscount.propTypes = {
  price: PropTypes.string.isRequired,
  discountPrice: PropTypes.string
};

PriceDiscount.propTypes = {
  discountPrice: null
};

export default PriceDiscount;
